import React, { useEffect } from 'react';

const useConsole = () => {
  useEffect(() => {
    console.log(
      '%c\n  ██████╗ █████╗ ███╗   ██╗██████╗  ██████╗  ██████╗ \n ██╔════╝██╔══██╗████╗  ██║██╔══██╗██╔═══██╗██╔═══██╗\n ██║     ███████║██╔██╗ ██║██║  ██║██║   ██║██║   ██║\n ██║     ██╔══██║██║╚██╗██║██║  ██║██║   ██║██║   ██║\n ╚██████╗██║  ██║██║ ╚████║██████╔╝╚██████╔╝╚██████╔╝\n  ╚═════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚═════╝  ╚═════╝  ╚═════╝ \n%c  Behzad Bakhshayesh\n',
      'color:#ff8601;',
      'font-family:monospace;color:#1c2767;font-size:12px;',
    );
  }, []);
};

export default useConsole;
